<template>
  <Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
    <form
      class="EditBoard_Form PForm"
      v-on:click.stop
      v-on:submit.prevent="onDone"
    >
      <p>
        <label for="name">Board Name</label>
        <input name="name" type="text" v-model="name" />
      </p>
      <p>
        <label class="m-inline" for="isTemplate">
          This board is a template
        </label>
        <input name="isTemplate" type="checkbox" v-model="isTemplate" />
      </p>
    </form>
    <div class="ButtonRow_Right">
      <button class="WBMBigButton m-primary" v-on:click="onDone">Done</button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { WhiteboardData } from "@/store/stateInterfaceType";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal } })
export default class EditBoardMetadataModal extends WBComponent {
  name = "";
  isTemplate = false;

  mounted() {
    this.name = this.state.whiteboard.name;
    this.isTemplate = this.state.whiteboard.isTemplate;
  }

  @Emit("done")
  onDone() {
    this.save();
    ModalMutations.closeModals(this.$store.commit);
  }

  save() {
    const newMetadata: Partial<WhiteboardData> = {
      name: this.name,
      isTemplate: this.isTemplate,
    };
    this.$store.dispatch("setWBMetadata", newMetadata);
  }
}
</script>

<style scoped lang="scss"></style>
